var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"schedule"},[(_vm.report.is_draft)?_c('ReportDraftWatermark'):_vm._e(),_c('h2',{staticClass:"formTitle"},[_vm._v("Schedule C: Corrections")]),_c('v-divider'),_c('C4ScheduleCReceipts',{attrs:{"report":_vm.report}}),_c('C4ScheduleCExpenses',{attrs:{"report":_vm.report}}),_c('C4ScheduleCRefunds',{attrs:{"report":_vm.report}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }